export const ACTION_STATUS_PENDING = 'ACTION_STATUS_PENDING';
export const ACTION_STATUS_SUCCESS = 'ACTION_STATUS_SUCCESS';
export const ACTION_STATUS_FAIL = 'ACTION_STATUS_FAIL';



// WEBPACK FOOTER //
// ./src/utils/redux/thunkActionConstants.js